import React from "react";
import {SvgIcon, SvgIconProps} from "@material-ui/core"


const LightBulbIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props}>
            <svg version="1.1" id="Layer_1" x="0px" y="0px"
                 viewBox="0 0 512 512">
                <g id="Group_599" transform="translate(-21.75 -1.75)">
                    <path id="Path_686" fill="fill:#3D4977;stroke:#3D4977;stroke-width:0.5;" d="M270.289,77.9
		c-84.518,4.11-149.7,75.958-145.59,160.475c2.191,45.058,24.128,86.86,59.962,114.263c19.54,15.485,30.814,39.141,30.536,64.071
		v6.561c-10.667,2.853-18.11,12.484-18.183,23.525v3.59c-0.01,13.546,10.963,24.536,24.509,24.547c0.013,0,0.025,0,0.038,0h4.19
		c-0.957,2.623-1.464,5.39-1.5,8.182v3.59c-0.01,13.546,10.963,24.536,24.509,24.547c0.013,0,0.025,0,0.038,0h57.885
		c13.546,0.01,24.536-10.963,24.547-24.509c0-0.013,0-0.025,0-0.038v-3.59c-0.035-2.792-0.542-5.559-1.5-8.182h4.19
		c13.546,0.01,24.536-10.963,24.547-24.509c0-0.013,0-0.025,0-0.038v-3.59c-0.006-11.064-7.464-20.736-18.164-23.553v-6.561
		c0.294-25.813,12.378-50.075,32.804-65.861c66.223-52.658,77.22-149.03,24.562-215.253C366.969,96.958,319.557,75.494,270.289,77.9
		z M314.894,483.066v3.59c-0.021,4.51-3.672,8.162-8.182,8.182h-57.885c-4.51-0.021-8.162-3.672-8.182-8.182v-3.59
		c0.021-4.51,3.672-8.162,8.182-8.182h57.885c4.503-0.005,8.158,3.641,8.164,8.145c0,0.013,0,0.025,0,0.038L314.894,483.066z
		 M342.14,450.431c-0.021,4.51-3.672,8.162-8.182,8.182H221.552c-4.51-0.021-8.162-3.672-8.182-8.182v-3.637
		c0.021-4.51,3.672-8.162,8.182-8.182H333.92c4.51,0.021,8.162,3.672,8.182,8.182L342.14,450.431z M251.422,313.517h-16.749
		c-6.776,0.005-12.273-5.484-12.278-12.259c0-0.006,0-0.013,0-0.019v-4.489c-0.005-6.776,5.484-12.273,12.259-12.278
		c0.006,0,0.013,0,0.019,0h4.489c6.776-0.005,12.273,5.484,12.278,12.259c0,0.006,0,0.013,0,0.019L251.422,313.517z
		 M287.751,422.295h-19.954v-92.507h19.954V422.295z M362.994,338.063c-24.351,18.852-38.7,47.84-38.924,78.636v5.624h-19.964
		v-92.507h16.796c15.804-0.036,28.606-12.839,28.643-28.643v-4.527c-0.036-15.804-12.839-28.606-28.643-28.643h-4.489
		c-15.804,0.036-28.606,12.839-28.643,28.643v16.768h-19.954v-16.768c-0.036-15.804-12.839-28.606-28.643-28.643h-4.499
		c-15.804,0.036-28.606,12.839-28.643,28.643v4.489c0.036,15.804,12.839,28.606,28.643,28.643h16.768v92.507h-19.964v-5.624
		c0.222-30.021-13.444-58.458-37.022-77.043c-60.042-45.896-71.509-131.776-25.613-191.818
		c24.471-32.013,61.808-51.614,102.055-53.575c75.541-3.685,139.768,54.566,143.453,130.107
		c2.144,43.944-16.956,86.242-51.339,113.692L362.994,338.063z M304.115,313.517v-16.767c-0.005-6.776,5.484-12.273,12.259-12.278
		c0.006,0,0.013,0,0.019,0h4.489c6.776-0.005,12.273,5.484,12.278,12.259c0,0.006,0,0.013,0,0.019v4.489
		c0.005,6.776-5.484,12.273-12.259,12.278c-0.006,0-0.013,0-0.019,0H304.115z"/>

                    <rect id="Rectangle_391" x="269.568" y="4.25" fill="fill:#3D4977;stroke:#3D4977;stroke-width:0.5;"
                          width="16.365" height="45.307"/>

                    <rect id="Rectangle_392" x="130.67" y="48.974"
                          transform="matrix(0.7071 -0.7071 0.7071 0.7071 -9.9793 119.1624)"
                          fill="fill:#3D4977;stroke:#3D4977;stroke-width:0.5;" width="16.365" height="45.307"/>

                    <rect id="Rectangle_393" x="394.011" y="63.487"
                          transform="matrix(0.7071 -0.7071 0.7071 0.7071 71.3605 315.6176)"
                          fill="fill:#3D4977;stroke:#3D4977;stroke-width:0.5;" width="45.307" height="16.365"/>

                    <rect id="Rectangle_394" x="44.232" y="202.339" fill="fill:#3D4977;stroke:#3D4977;stroke-width:0.5;"
                          width="45.307" height="16.365"/>

                    <rect id="Rectangle_395" x="465.961" y="202.339"
                          fill="fill:#3D4977;stroke:#3D4977;stroke-width:0.5;" width="45.307" height="16.365"/>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
            </svg>

        </SvgIcon>
    )
};

export default LightBulbIcon;